import React from "react";
import {observer} from 'mobx-react';
import {computed, observable} from 'mobx';
import {ProfileField} from 'components/inputs';

@observer
class ContractDetails extends React.Component {

    @observable
    state = {
        lists: {
            working_schedules: []
        }
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {defaultValue} = this.props;
        return <React.Fragment>
            <div className="row sec-group margin-0">
                <hr className="margin-b-10 hor-center w-200"/>
                <label className="margin-b-0 w-full text-center">Contract Terms</label>
                <ProfileField title="Contract Type" name="contract_type" value={defaultValue && defaultValue.contract_type} className="col-lg-6 pull-left-3"/>
                <ProfileField title="Start Date" name="start_date" value={defaultValue && defaultValue.start_date} type="date" className="col-lg-4"/>
                <ProfileField title="End Date" name="expiry_date" value={defaultValue && defaultValue.expiry_date} type="date" className="col-lg-4"/>
                <ProfileField title="End Of Trial Period" name="end_of_trial_period" value={defaultValue && defaultValue.end_of_trial_period} type="date" className="col-lg-4"/>
            </div>
            <div className="row sec-group margin-0">
                <hr className="margin-b-10 hor-center w-200"/>
                <label className="margin-b-0 w-full text-center">Working Schedule</label>
                <ProfileField name="start_time" type="time" placeholder="Start Time" value={defaultValue && defaultValue.start_time} className="col-lg-4"/>
                <ProfileField name="end_time" type="time" placeholder="End Time" value={defaultValue && defaultValue.end_time} className="col-lg-4"/>
                <ProfileField name="daily_working_hours" type="number" placeholder="Daily Working Hours" value={defaultValue && defaultValue.daily_working_hours} className="col-lg-4"/>
            </div>
            <div className="row sec-group margin-0">
                <hr className="margin-b-10 hor-center w-200"/>
                <label className="margin-b-0 w-full text-center">Notes</label>
                <ProfileField title="Notes" name="notes" value={defaultValue && defaultValue.notes} type="textarea" className="col-lg-12"/>
            </div>
        </React.Fragment>;
    }
}

@observer
class SalaryInfo extends React.Component {

    @observable
    state = {
        lists: {
            payment_types: [{text: 'Salary (Fixed Payment)', value: 'Salary', checked: false}, {text: 'Hourly Wage', value: 'Wage', checked: false}],
            salary_intervals: [
                {text: 'Weekly', value: 'Weekly', checked: false}, 
                {text: 'Bi-Weekly', value: 'Bi-Weekly', checked: false}, 
                {text: 'Monthly', value: 'Monthly', checked: false}
            ],
            wage_types: []
        }
    };

    constructor(props) {
        super(props);
    }

    get item() {
        return this.props.item;
    }

    render() {
        const {defaultValue} = this.props;
        const payment_type = defaultValue && defaultValue.payment_type;
        const salary_interval = defaultValue && defaultValue.salary_interval;
        const salary = defaultValue && (defaultValue.salary && defaultValue.salary.toCurrency('R')) || "N/A";
        
        const wage = defaultValue && defaultValue.wage;
        return <React.Fragment>
            <div className="row sec-group margin-0">
                <ProfileField title="Payment Type" name="payment_type" value={payment_type} className={"col-lg-" + (payment_type==="Salary" ? "4" : "6")}/>
                {payment_type==="Salary" && <ProfileField title="Salary Interval" name="salary_interval" value={salary_interval} className="col-lg-4"/>}
                {payment_type==="Salary" && <ProfileField title="Salary" name="salary" value={salary} className="col-lg-4"/>}
                {payment_type==="Wage" && <ProfileField title="Wage" name="wage" value={wage} className="col-lg-6"/>}
            </div>
            <Deductibles defaultValue={defaultValue && defaultValue.deductible && defaultValue.deductible.list}/>
        </React.Fragment>;
    }
}

@observer
class Deductibles extends React.Component {

    constructor(props) {
        super(props);
    }
    
    @computed
    get list() {
        return (this.props.defaultValue || []).filter(v => !!v && !!v.value);
    }
    
    @computed
    get calculate() {
        const {list} = this;
        const l = list.filter(({text, value}) => text && value).map(({value}) => value);
        const total = l.reduce((n1, n2) => n1 + n2, 0);
        return total;
    }
    
    render() {
        return <div className="row sec-group margin-0">
            <hr className="margin-r-10"/>
            <label className="hor-center margin-b-0">Deductibles</label>
            <div className="row margin-l-0 margin-r-0">
                {this.list.isEmpty() && "N/A"}
                {this.list.map((item, n) => <Deductible item={item}/>)}
            </div>
            {!this.list.isEmpty() && <hr  className="hor-center w-100"/>}
            {!this.list.isEmpty() && <label className="hor-center margin-b-15">Deductibles Total : {this.calculate.toCurrency('R')}</label>}
        </div>;
    }
}

@observer
class Deductible extends React.Component {

    render() {
        const {text, value} = this.props.item;
        return <ProfileField name="value" value={value.toCurrency('R')} placeholder={text} className="col-lg-6"/>;
    }
}

export {ContractDetails, SalaryInfo};
